import React from "react";
import Image from "react-bootstrap/Image";

export const IconboxReusableComponent = ({
  classSection,
  src,
  alt,
  onClick,
  title,
}) => {
  return (
    <React.Fragment>
      <div className={classSection} onClick={onClick}>
        <Image
          src={src}
          alt={alt}
          title={title}
          fluid
          className="restaurant-chain-icon-box-image"
        />
      </div>
    </React.Fragment>
  );
};
